import { jsPDF } from 'jspdf';

function loadImage(url: any) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = (err) => reject(err);
        img.src = url;
    });
}

export async function printQR(din: any, blockLabels: any, sampleLabels: any) {

    var labels: any = []
    sampleLabels = sampleLabels || "PPN Number"
    for (let i = 0; i < blockLabels.length; i++) {
        labels.push(blockLabels[i]);
    }

    var res = {
        data: {
            deidentifiedData: din,
            blockLable: labels,
            testDetails: sampleLabels
        }
    }

    if (res && res.data) {
        const doc = new jsPDF({
            orientation: "landscape",
            unit: "mm",
            format: [21, 7],
        });
        const data = res.data.deidentifiedData;
        const qrCodeUrl: any = `https://api.qrserver.com/v1/create-qr-code/?size=1000x1000&data=` + encodeURIComponent(data);
        const img: any = await loadImage(qrCodeUrl);
        const qrCodeWidth = 5;
        const qrCodeHeight = 5;
        doc.addImage(img, "PNG", 1, 2, qrCodeWidth, qrCodeHeight);
        doc.setFontSize(6);
        const text = doc.splitTextToSize(res.data.testDetails, 12);
        const lineHeight = 1.2;
        const totalTextHeight = text.length * lineHeight;
        const startY = (7 - totalTextHeight) / 2;
        doc.text(text, 8, startY + 1.5);
        if (res.data.blockLable.length !== 0) {
            for (let i = 0; i < res.data.blockLable.length; i++) {
                doc.addPage();
                doc.addImage(img, "PNG", 1, 2, qrCodeWidth, qrCodeHeight);
                const blockText = doc.splitTextToSize(res.data.blockLable[i], 12);
                const blockTotalTextHeight = blockText.length * lineHeight;
                const blockStartY = (7 - blockTotalTextHeight) / 2;
                doc.text(blockText, 8, blockStartY + 1.5);
            }
        }
        const pdfBlob = doc.output("blob");
        const printWindow: any = window.open('', '', 'width=800,height=600');
        printWindow.document.write('<html><head><title>Print</title></head><body>');
        printWindow.document.write('<embed width="100%" height="100%" src="' + URL.createObjectURL(pdfBlob) + '" type="application/pdf">');
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.onload = function () {
            printWindow.print();
            printWindow.onafterprint = function () {
                printWindow.close();
            };
        };
    }
}
